import React from 'react'

export const Plane = ({ fill }) => (
<svg width="56.6929px" height="34.1174px" viewBox="0 0 56.6929 34.1174">

<g fill={fill}>
	<g>
		<path class="st0" d="M23.5208,10.072c-0.112,0-0.226-0.0284-0.3297-0.0888L18.309,7.1627
			c-0.2332-0.1347-0.3612-0.3973-0.3235-0.6641c0.0377-0.2668,0.2332-0.484,0.4949-0.5485
			c4.3057-1.0702,9.4246,0.2369,12.0914,1.111c0.3468,0.1135,0.5356,0.4866,0.4221,0.8329
			c-0.113,0.3468-0.4871,0.5372-0.8329,0.4221c-2.1693-0.7106-6.0385-1.7256-9.6037-1.3798l3.2943,1.9036
			c0.3158,0.1822,0.4242,0.5862,0.2415,0.902C23.9708,9.9539,23.7489,10.072,23.5208,10.072z"/>
	</g>
	<g>
		<path class="st0" d="M36.1344,17.1193c-0.2941,0-0.5619-0.1976-0.6388-0.4954c-0.0913-0.3535,0.1213-0.7137,0.4742-0.8045
			l12.8216-3.3098c0.5604-0.1522,0.983-0.4923,1.2498-1.0093c0.4128-0.8014,0.3813-1.8886,0.1367-2.5486
			c-0.1269-0.3421,0.0475-0.7224,0.3896-0.8489c0.3426-0.128,0.7224,0.0475,0.8489,0.3896c0.3457,0.933,0.4175,2.4119-0.2007,3.6127
			c-0.4376,0.8489-1.159,1.4299-2.0863,1.6812L36.3,17.0982C36.2448,17.1126,36.1891,17.1193,36.1344,17.1193z"/>
	</g>
	<g>
		<path class="st0" d="M23.4109,32.0194c-0.1228,0-0.2441-0.0093-0.3633-0.0268c-1.0073-0.1502-1.5821-0.9077-1.7627-1.3313
			c-0.0661-0.1543-0.0707-0.3287-0.0129-0.4866l4.59-12.5187c0.1254-0.3416,0.5042-0.5171,0.8478-0.3927
			c0.3421,0.1259,0.5181,0.5052,0.3927,0.8478l-4.4796,12.2168c0.1171,0.1414,0.3225,0.3184,0.6363,0.3607
			c0.5578,0.0748,1.8458-0.2126,4.1674-2.964l9.3425-13.691c0.2059-0.3024,0.6177-0.3788,0.9175-0.1734
			c0.3014,0.2054,0.3793,0.6166,0.1734,0.9175l-9.3611,13.7189c-0.0124,0.0186-0.0258,0.0361-0.0402,0.0532
			C26.5194,30.8542,24.8237,32.0189,23.4109,32.0194z"/>
	</g>
	<g>
		<path class="st0" d="M13.4161,21.4111c-2.3051,0-4.6849-0.2229-6.7062-0.8783c-0.208-0.0676-0.369-0.2338-0.4304-0.4438
			l-0.3313-1.1373c-0.0495-0.1708-0.0284-0.3545,0.0588-0.5093c0.0877-0.1548,0.2338-0.2683,0.4061-0.3137l3.2184-0.8545
			l-4.461-5.2639c-0.2358-0.2787-0.2018-0.6951,0.0764-0.9309l0.5083-0.4309c0.1858-0.1579,0.4427-0.2002,0.6693-0.1109
			l8.2202,3.236l26.0116-6.5179c0.2276-0.0588,5.7505-1.4727,8.8673-0.1429c0.8102,0.3462,1.4036,0.7266,1.7627,1.1301
			c0.1538,0.1729,0.2064,0.4138,0.1373,0.6352c-0.0686,0.2209-0.2482,0.3901-0.4732,0.4453l-4.654,1.1435
			c-0.3535,0.0851-0.7121-0.13-0.7988-0.484c-0.0872-0.354,0.1295-0.7116,0.484-0.7988l3.189-0.7833
			c-0.0532-0.0243-0.1084-0.0485-0.1662-0.0733c-2.6988-1.1512-7.9684,0.1945-8.0215,0.2085l-26.2226,6.5705
			c-0.1336,0.0325-0.275,0.0237-0.4025-0.0263l-7.2841-2.867l4.2412,5.0038c0.1465,0.1729,0.1945,0.4087,0.1264,0.6249
			c-0.0676,0.2162-0.2415,0.3824-0.4608,0.4407L7.406,19.2319l0.0423,0.146c5.8754,1.7199,15.0662-0.2492,15.1602-0.2699
			c0.3576-0.0784,0.7085,0.1481,0.7859,0.5047c0.0779,0.3566-0.1476,0.7085-0.5042,0.7859
			C22.6178,20.4585,18.1784,21.4111,13.4161,21.4111z"/>
	</g>
</g>
</svg>

)

